import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BaseService} from './base.service';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({providedIn: 'root'})
export class BlogCategoryService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    list(params: any = {}): Observable<any> {
        return this.getRequest(AppUrl.BLOG_CATEGORIES(), params);
    }

    create(payload: any): Observable<any> {
        return this.postRequest(AppUrl.BLOG_CATEGORIES(), payload);
    }

    update(id: number | string, payload: any): Observable<any> {
        return this.putRequest(AppUrl.BLOG_CATEGORY(id), payload);
    }

    remove(id: number | string): Observable<any> {
        return this.deleteRequest(AppUrl.BLOG_CATEGORY(id));
    }
}
